
  // ═══════════════════════════════════════════════════════════════
  // VARIABLES À CUSTOMISER POUR CHAQUE PAGE
  // ═══════════════════════════════════════════════════════════════
  const CONFIG = {
    lieuCible: null,
    splatURL: "./assets/chomo/models/chomo_eglise_500k_pycut_15000_clean.splat",
    meshURL: null,
    planURL: null,
    camPosX: 5,
    camPosY: 5,
    camPosZ: 5,
    camRotX: 0,
    camRotY: 0,
    camRotZ: 0,
    camTargetX: 0.2,
    camTargetY: 0,
    camTargetZ: 0,
    camMinDistance: 0.1,
    camMaxDistance: 35
  };
  // ═══════════════════════════════════════════════════════════════
  
  import { initViewer } from './spark_viewer.js';
  initViewer(CONFIG);
